export const EVENT_CONSENT_CHANGED = 'tuic:consentChanged';

export const EVENT_PAGE_VIEW_SENT = 'tuic:pageViewSent';

export const EVENT_TRACKER_READY = 'tuic:trackerReady';
